var map = {
	"./00.jpg": 1660,
	"./01.jpg": 1661,
	"./02.jpg": 1662,
	"./03.jpg": 1663,
	"./04.jpg": 1664,
	"./05.jpg": 1665,
	"./06.jpg": 1666,
	"./07.jpg": 1667,
	"./08.jpg": 1668,
	"./09.jpg": 1669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1659;